module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('div', {
    staticClass: "body Chapter",
    attrs: {
      "id": "section_chapter--num_2--seq_5"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_105844-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_12"
    }
  })]), _c('div', {
    staticClass: "title-block",
    attrs: {
      "id": "rw-title-block_105844-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_12"
    }
  }), _c('p', {
    staticClass: "title-num"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_12"
    }
  }), _c('a', {
    attrs: {
      "href": "#/9781847675095_toc"
    }
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("CHAPTER TWO")])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_vm._v("SHORTLY AFTER NOON on the following day the Count was driving home to lunch. He was displeased to observe an unusual number of German soldiers on the streets, and the occasional sound of distant gunfire brought a little frown to his forehead. But when he entered the Piazza di Spagna his attention was taken by the exceptional colour of the flower-sellers’ stalls, and ordering his driver to stop, he got out and bought, in wilful defiance of the hour, a bunch of every variety displayed. These he sent, by a convenient boy whom he found waiting beside the stall, to his dear friend the Marchesa Dolce, who lived in a small house high above the Piazza. The boy with his many-coloured, scented burden slowly climbed the steps, and the Count returned to his car.")]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00002"
    }
  }, [_vm._v("Having lunched alone he sent for Angelo, and at once complimented him on his improved appearance. Cleanly shaved and diligently washed, smartly attired in a new uniform, Angelo now looked a credit to his regiment. Embracing him, the Count lightly stroked his hair and said with a sigh, ‘Mine still grows as thick as yours, but it’s turning grey. The first of the winter snow has fallen on it.’")]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00003"
    }
  }, [_vm._v("‘In the most attractive manner,’ said Angelo.")]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00004"
    }
  }, [_vm._v("‘It is not uncomely, I have been assured of that,’ the Count agreed, ‘but white hairs are a warning of the coldness that comes with age, and I do not like them. – That, however, is a topic we can discuss at some more convenient time. There is an affair of the moment that we must talk about now. The fact of the matter is that we are living in difficult and dangerous days.’")]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00006"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_13"
    }
  }, [_vm._v("‘Have the English and the Americans changed their minds? Are they not coming to liberate us?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00007"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_13"
    }
  }, [_vm._v("‘Of course they are, but the process may take some weeks, and in the meanwhile the Tedeschi are in power. The King and Marshal Badoglio have fled from Rome, and General von Kluggenschaft, whose troops control the city, has made it perfectly clear that he no longer regards us as his loyal friends and indispensable allies.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00008"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_13"
    }
  }, [_vm._v("‘How many of our soldiers have the Tedeschi killed?’ asked Angelo.")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00009"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_13"
    }
  }, [_vm._v("‘Several score, I believe – but we must not let emotion obscure intelligence. We must remember, my dear Angelo, that the soldier’s anticipation of a violent end is part of his contract. The shadow of the recruiting sergeant is very like the shadow of death, and a soldier’s life, even in our army, is a flimsy structure. We must be practical – and to come to the point, I want you to take some of my pictures to Pontefiore, where, I think, they will be safer for the next few weeks than they might be in Rome.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00010"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_13"
    }
  }, [_vm._v("‘That is prudent indeed. You are sending the Piero della Francesca?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00011"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_13"
    }
  }, [_vm._v("‘That, and my little Raphael, the two small Bronzinos, and Simone Martini’s portrait of Petrarch. I have several others packed up; the Filippino Lippi, and the Lorenzo di Credi with the light blue sky. Indeed, the best of my small collection is going, and though I do not for a moment suppose that the Germans would take them from me, I shall feel happier when they are in Pontefiore, where the Countess will be able to find secure hiding-places for them.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00012"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_13"
    }
  }, [_vm._v("‘But how am I to take them there?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00013"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_13"
    }
  }, [_vm._v("An arrangement had been made, the Count assured him. Several weeks before, in preparation for an emergency, he had had the pictures packed in wooden cases, and that very morning he had called on General von Kluggenschaft to ask for the loan of two German army lorries.")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00014"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_13"
    }
  }, [_vm._v("‘So you and the General are friends, are you?’ asked Angelo.")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00016"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_14"
    }
  }, [_vm._v("‘Far from it,’ said the Count. ‘He has a revolting personality, and whenever I see him I have to be extraordinarily polite in order to prevent an open quarrel. But as I needed his lorries I offered to sell him some wine if he would provide me with the necessary transport to bring it here. I mentioned an absurdly low price, his greed was instantly aroused, and when he had further diminished my figure we closed the bargain. Come, now, and let me show you the vehicles in which you will travel.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00017"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_14"
    }
  }, [_vm._v("In a small courtyard the lorries were already loaded, and their drivers, in German uniform, stood beside them. With wooden precision they came to attention and saluted.")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00018"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_14"
    }
  }, [_vm._v("‘You need not be very frightened of them,’ said the Count. ‘Like so many people in the army of our late ally, they are not real Germans, but wretched prisoners forced into service. This one is a Czech, and that, I believe, some sort of a Russian who was taken captive in the Caucasus.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00019"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_14"
    }
  }, [_vm._v("‘They don’t look very happy,’ said Angelo.")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00020"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_14"
    }
  }, [_vm._v("‘They have very little reason to,’ replied the Count, and unlacing the canvas cover of the nearer lorry he revealed how well it had been loaded. The pictures in their wooden cases were only a small part of the cargo. The bulk of it was softly filled sacks among which the cases stood, gently held and firmly guarded.")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00021"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_14"
    }
  }, [_vm._v("Angelo fingered one of the sacks and exclaimed, ‘But this is flour.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00022"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_14"
    }
  }, [_vm._v("‘That is so,’ said the Count.")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00023"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_14"
    }
  }, [_vm._v("‘And is the other lorry loaded in the same way?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00024"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_14"
    }
  }, [_vm._v("‘In precisely the same way. I had been wondering how to protect these old and immensely valuable pictures against the jolting and tremors of a long journey, when I happened to remember that I had a certain stock of flour available.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00025"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_14"
    }
  }, [_vm._v("‘How very fortunate,’ said Angelo.")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00026"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_14"
    }
  }, [_vm._v("‘A lucky chance,’ agreed the Count, and having told the drivers to be ready to move within half an hour, he invited Angelo to have a glass of wine before he set off.")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00027"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_14"
    }
  }, [_vm._v("They drank a glass or two in the small library where Angelo had already been received. Neither spoke for a few ")]), _c('a', {
    attrs: {
      "id": "pb-rw_15"
    }
  }, [_vm._v("minutes, and then the Count asked, ‘Were you ever hungry when you were in Africa?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00028"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_15"
    }
  }, [_vm._v("‘We came near to starvation once or twice,’ said Angelo.")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00029"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_15"
    }
  }, [_vm._v("‘Those English submarines sank hundreds of our ships,’ said the Count. ‘At certain times they were sinking so many that it really seemed useless to send you any stores at all. Ship after ship we loaded, and what happened to them? They went to the bottom of the sea. Our labour and our goods were wasted. Utterly wasted. And now and again I felt that I could no longer be a partner in such destruction. My whole being rebelled against the idea of sending, to no other destination than the engulfing waves, great shiploads of boots and shirts and guns and ammunition and oil –’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00030"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_15"
    }
  }, [_vm._v("‘And flour,’ said Angelo.")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00031"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_15"
    }
  }, [_vm._v("‘And flour,’ the Count agreed.")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00032"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_15"
    }
  }, [_vm._v("‘The lorries, then, are loaded with what should have been sent to your regiment in Africa?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00033"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_15"
    }
  }, [_vm._v("‘And if the regiment had been commanded by a man less prudent than I, it might indeed have been dispatched,’ declared the Count. ‘And what would have happened to it?’ he demanded. ‘It would have gone, like so many other cargoes, to the bottom of the sea. What horrible and wicked waste, when all over Italy our peasants are in just as great a need of flour as ever our poor soldiers were!’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00034"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_15"
    }
  }, [_vm._v("‘So you are sending it to Pontefiore to be given away to anyone who is hungry?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00035"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_15"
    }
  }, [_vm._v("‘Not "), _c('i', [_vm._v("given")]), _vm._v(",’ said the Count. ‘Our Tuscan peasants are proud people who would not ask to live on charity. I am too much devoted to their welfare to wish to pauperize them. No, no! But my steward has orders to sell the flour at a fair and just price, and it will, I am sure, be very welcome to all my people. – And now, Angelo, it is time for you to leave. Here is your pass, and the permission signed by von Kluggenschaft for two motor lorries to go to Pontefiore for some urgently needed military equipment. I do not think you will have any difficulty on the road, but if you are stopped, by some officious Tedescho, you will find in each lorry a dozen bottles of wine, and that will certainly ")]), _c('a', {
    attrs: {
      "id": "pb-rw_16"
    }
  }, [_vm._v("dissolve the obstruction. God bless you, my boy, and give this letter to the Countess. Tell her that I am well, in spite of my grey hairs.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00036"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_16"
    }
  }, [_vm._v("Angelo was appreciably moved by the kindness with which the Count had treated him, and he was forced to admit that there was something to be said for the prudence which had saved so much flour from the British Navy, and now, with an equal regard for the appetite and dignity of a Tuscan peasant, was sending it where it would certainly be useful. Stammering a sentence or two of gratitude, he took his leave, and, descending to the courtyard, elected to travel in the lorry driven by the Czech soldier. The Czech was a smaller man than the Russian.")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00037"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_16"
    }
  }, [_vm._v("Suddenly a vision filled his mind, an enchanted view of the home that he had not seen for three long years, the landscape lighted with the dark green candle-flames of the cypress trees, and his boyhood’s sweetheart. Ah, the black eyes and the milk-white throat of dear Lucrezia! He was going home, and as he spoke the words aloud, to give them reality, his eyes filled with tears and he failed to notice the German staff-car that stopped before the Count’s front door at the very moment when the flour-laden lorries drove past.")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00038"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_16"
    }
  }, [_vm._v("The Count was composing himself for his siesta when he was informed that two German officers desired to see him. He returned the answer that at three o’clock in the afternoon he could receive no one, but his reply was ignored and a moment or two later the library door was thrown rudely open, and two heavy-footed steel-helmeted Germans marched in.")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00039"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_16"
    }
  }, [_vm._v("What louts they are, thought the Count, and in his most courteous voice inquired, ‘To what am I indebted for this honour, gentlemen?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00040"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_16"
    }
  }, [_vm._v("‘You are Lieutenant-Colonel the Count Agesilas Piccologrando of Pontefiore?’ asked the senior and more repellent of his visitors.")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00041"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_16"
    }
  }, [_vm._v("‘I am.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00042"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_16"
    }
  }, [_vm._v("‘Then you are under arrest.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00044"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_17"
    }
  }, [_vm._v("‘Really,’ said the Count. ‘May I offer you a glass of wine?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00045"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_17"
    }
  }, [_vm._v("Unhappy Angelo, he thought, I suppose they were waiting for him when he went down. But I cannot believe that this is going to be a serious matter. The flour is not theirs, and never was, and I fail to see that they have any legal claim to it now. Nor did von Kluggenschaft specify for what purpose the lorries were to be used on the outward journey …")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00046"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_17"
    }
  }, [_vm._v("These musings were interrupted by the German who had already spoken, and now, having swallowed his wine, said harshly, ‘Last night you treacherously endeavoured to interfere with certain gunners of a German battery then in action against a regiment of Italian rebels and traitors.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00047"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_17"
    }
  }, [_vm._v("‘Last night?’ said the Count, who was much surprised. ‘Last night? Why, yes, I remember now. Of course I did. So that is what has brought you here. Well, well!’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00048"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_17"
    }
  }, [_vm._v("‘Your attempt to obstruct the gun-crew in the execution of its duty was observed by Major Fluchs, commanding the battery, who promptly put you under open arrest.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00049"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_17"
    }
  }, [_vm._v("‘Poor Fluchs. And now he is dead.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00050"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_17"
    }
  }, [_vm._v("‘Before he died, however, he regained consciousness long enough to inform Captain Bluther of his action.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00051"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_17"
    }
  }, [_vm._v("Captain Bluther, the other officer, looked proudly over the Count’s head and spoke in a loud voice: ‘With his last breath Major Fluchs did his duty as a German should, and expressed the wish that the Count Piccologrando should be punished for his swinish behaviour with appropriate severity.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00052"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_17"
    }
  }, [_vm._v("‘I am amazed,’ said the Count. ‘I thought he was dead when I left him. Had you asked me, I should have said that he died in my arms. But there is, of course, no truth in those last rambling words of his. Poor fellow, his mind was wandering. You cannot be so foolish as to arrest me on no surer evidence than a fragment of delirious conversation which I shall totally deny, and which you cannot substantiate by witnesses; for none of them survives.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00053"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_17"
    }
  }, [_vm._v("‘The word of a German officer does not require witnesses to prove it nor evidence to substantiate it, and is utterly ")]), _c('a', {
    attrs: {
      "id": "pb-rw_18"
    }
  }, [_vm._v("indifferent to events which contradict it or enemies who deny it.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00054"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_18"
    }
  }, [_vm._v("‘In that case,’ said the Count, ‘I think I had better telephone to General von Kluggenschaft, who is my very good friend. You will excuse me?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00055"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_18"
    }
  }, [_vm._v("‘You will be wasting your time. The General is no longer in command.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00056"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_18"
    }
  }, [_vm._v("‘He was in command this morning. I know that, because I saw him.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00057"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_18"
    }
  }, [_vm._v("‘He is now on his way to the Führer’s Headquarters. He was replaced an hour ago by General Hammerfurter.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00058"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_18"
    }
  }, [_vm._v("‘But why? I cannot understand it. He was an excellent soldier. He did his work with admirable efficiency, and he was universally popular.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00059"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_18"
    }
  }, [_vm._v("The senior of the German officers smiled sourly, but Captain Bluther indignantly explained: ‘General von Kluggenschaft had formed a most undesirable friendship in Rome. He was on intimate terms with a woman of vicious character whose other associates were known to engage in subversive conversation.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00060"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_18"
    }
  }, [_vm._v("‘That is slanderous!’ declared the Count fiercely. ‘Your statement contains a monstrous and abominable slander!’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00061"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_18"
    }
  }, [_vm._v("‘What are your grounds for saying that?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00062"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_18"
    }
  }, [_vm._v("‘General von Kluggenschaft was on intimate terms with one lady only in Rome, and of all her sex she is the most lovely, prudent, and desirable. He was entirely faithful to her – and had he ever been unfaithful, he would have had to deal with me!’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00063"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_18"
    }
  }, [_vm._v("‘You refer to the Marchesa Dolce?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00064"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_18"
    }
  }, [_vm._v("‘As the name is known to you – I do.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00065"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_18"
    }
  }, [_vm._v("‘So you know her also, do you?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00066"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_18"
    }
  }, [_vm._v("The Count’s brief anger subsided. For a moment he stood, very straight and still, and then, his slim figure losing its rigidity like a tall reed when the morning wind blows up the river-bed, he slightly bowed and very quietly answered, ‘For seven years she has been my dearest friend.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00067"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_18"
    }
  }, [_vm._v("Captain Bluther shuffled his feet, coughed behind his hand, and was clearly embarrassed; but his senior and ")]), _c('a', {
    attrs: {
      "id": "pb-rw_19"
    }
  }, [_vm._v("more repellent companion lost his temper, raised his voice, and began to abuse his prisoner in violent language. The Marchesa Dolce was widely known to be a beautiful, witty, and cultivated woman, and this poor German, who had been on close terms only with some ungainly girls in Wuppertal and Bochum, and with overworked foreign prostitutes, was wildly jealous of the Count – whose nation he despised – and therefore became furiously angry with him, because of his good fortune and superior happiness in knowing such a charming person as the Marchesa.")])]), _c('p', {
    attrs: {
      "id": "rw-p_105844-00068"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_19"
    }
  }, [_vm._v("The Count did not know how to reply. He was in no degree frightened of the German, but so deeply shocked by the display of violent rage that he could not protect himself against it. And in this state of helplessness, urged on by a pair of automatic pistols, he was presently marched out of his house, into the waiting car, and removed to a large villa on the outskirts of Rome which was maintained by the Schutzstaffel for their own peculiar purposes.")])])]), _c('a', {
    attrs: {
      "id": "pb-rw_19"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_19"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c79f806e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781847675095_chapter_02.vue
// module id = 72
// module chunks = 0